import React, { useState, useRef } from 'react';
import { UploadCloudIcon, FileTextIcon } from 'lucide-react';
export function UploadBillBanner() {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dragActive, setDragActive] = useState(false);
  const [fileName, setFileName] = useState<string | null>(null);
  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') setDragActive(true);else if (e.type === 'dragleave') setDragActive(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files?.[0]) {
      setFileName(e.dataTransfer.files[0].name);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      setFileName(e.target.files[0].name);
    }
  };
  return <section className="relative overflow-hidden" data-id="element-320">
      {/* Background with network pattern */}
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/90 via-blue-500/80 to-blue-600/90" data-id="element-321" />
      <div className="absolute inset-0 opacity-30" style={{
      backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255,255,255,0.2) 0%, transparent 50%)'
    }} data-id="element-322" />
      {/* Subtle network lines */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'linear-gradient(45deg, rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(-45deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-323" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-324">
        <div className="bg-white/15 backdrop-blur-md rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 border border-white/20" data-id="element-325">
          {/* Left content */}
          <div className="flex-1" data-id="element-326">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-327">
              Upload your bill and get better pricing
            </h2>
            <p className="text-white/80 leading-relaxed max-w-xl" data-id="element-328">
              Upload your current telecom bill and our specialists will analyze
              it line by line. We'll identify overcharges, unnecessary fees, and
              savings opportunities — typically within 30 minutes.
            </p>
          </div>

          {/* Upload area */}
          <div onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop} onClick={() => fileInputRef.current?.click()} className={`flex-shrink-0 w-full md:w-64 cursor-pointer rounded-2xl p-6 flex flex-col items-center justify-center text-center transition-all ${dragActive ? 'bg-white/30 border-2 border-white scale-105' : fileName ? 'bg-green-900/80 border border-green-400/30' : 'bg-slate-900 border border-white/10 hover:bg-slate-800'}`} data-id="element-329">
            <input ref={fileInputRef} type="file" className="hidden" accept=".pdf,.png,.jpg,.jpeg,.doc,.docx" onChange={handleFileChange} data-id="element-330" />
            {fileName ? <>
                <FileTextIcon className="w-8 h-8 text-green-400 mb-2" data-id="element-331" />
                <p className="text-white font-bold text-sm" data-id="element-332">File selected</p>
                <p className="text-white/70 text-xs mt-1 truncate max-w-full" data-id="element-333">
                  {fileName}
                </p>
              </> : <>
                <UploadCloudIcon className="w-8 h-8 text-white mb-2" data-id="element-334" />
                <p className="text-white font-bold" data-id="element-335">Upload bill</p>
                <p className="text-white/70 text-xs mt-1" data-id="element-336">
                  Upload bill from your device or drag and drop file here
                </p>
              </>}
          </div>
        </div>
      </div>
    </section>;
}